// @todo name value per project
export const LOCALSTORAGE_AUTH_TOKENS_KEY = "app_survey_token_v1";
export const LOCALSTORAGE_AUTH_REFRESH_TOKENS_KEY = "app_survey_refresh_token_v1";